var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-6 h-6",
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.29 18.04l1.414 1.414-6.998 6.998a.997.997 0 01-1.414 0l-3.5-3.499 1.414-1.414 2.793 2.792 6.29-6.291zm0-11.373l1.414 1.414-6.998 6.998a.997.997 0 01-1.414 0l-3.5-3.499 1.414-1.414 2.793 2.792 6.29-6.291zm-.335 25.909l-3.23 3.23 3.23 3.229-1.414 1.414-3.23-3.229-3.23 3.229-1.414-1.414 3.23-3.229-3.23-3.23 1.414-1.414 3.23 3.23 3.23-3.23 1.414 1.414zm19.288 10.61a.806.806 0 01-.805.805H8.806A.806.806 0 018 43.186V4.806C8 4.361 8.36 4 8.806 4h29.632c.444 0 .805.361.805.806v38.38zM38.438 2H8.806A2.81 2.81 0 006 4.806v38.38a2.81 2.81 0 002.806 2.805h29.632a2.808 2.808 0 002.805-2.805V4.806A2.809 2.809 0 0038.438 2z",
    fill: "#BF0816",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.ca5a310e1e3050252cef72c17d7c37e6.svg";
export { ForwardRef as ReactComponent };